import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ServiceCard } from "./ServiceCard";
import { Col, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  // deleteService,
  serviceList,
  setserviceData,
} from "../../../../../redux/actions/dbactions/ServicesActions";

import { refTypesList } from "../../../../../redux/actions/dbactions/refactions";

import { getSession } from "../../../../../redux/actions/authActions";
import { getPatientList } from "../../../../../redux/actions/dbactions/pateints";
import { Header } from "../../../../Header";
import OrdersIcon from "../../../../../../assets/OrdersIcon";

export const OrderServicesOpen = () => {
  // const [show, setShow] = useState(false);
  // const [addmodal, setAddmodal] = useState(false);
  // const [editmodal, setEditmodal] = useState(false);
  const { facilityId } = useParams();
  const location = useLocation();
  const { svcf_user_profile_id } = location.state || {};
  const { role_id } = getSession();
  const dispatch = useDispatch();
  const { service, isLoading } = useSelector((state) => state.serviceList);
  // const [selectedTitle, setSelectedTitle] = useState(null);
  // const [selectedId, setSelectedId] = useState(null);
  const [selectedCardId, setSelectedCardId] = useState(null);
  // const [refresh, setRefresh] = useState(false);
  // const [sysId, setSysId] = useState(null);
  const { serviceID } = useParams();
  const [serviceUser, setServiceUser] = useState("");
  const [userData, setUserData] = useState({});

  // const { exploreList } = useSelector((state) => state.exploreReducer);
  // const explorelist = exploreList.usr?.rec || [];
  // const filterList = explorelist.filter((item) => item.svcf_id === facilityId);
  // Fetch newOrder from local storage
  useEffect(() => {
    const newOrder = JSON.parse(localStorage.getItem("newOrder"));
    if (newOrder) {
      setUserData(newOrder);
    }
  }, []); // Empty dependency array ensures this effect runs only once, similar to componentDidMount

  useEffect(() => {
    dispatch(serviceList(facilityId));
    dispatch(refTypesList());
  }, [facilityId, dispatch]);
  useEffect(() => {
    dispatch(getPatientList());
  }, [dispatch, serviceID]);
  // Fetch newOrder from local storage
  useEffect(() => {
    const newOrder = JSON.parse(localStorage.getItem("newOrder"));
    if (newOrder) {
      const firstName = newOrder.service_user;
      setServiceUser(firstName);
    }
  }, []); // Empty dependency array ensures this effect runs only once, similar to componentDidMount

  // useEffect(() => {
  //   const newPatient = JSON.parse(localStorage.getItem("newPatient"));
  //   if (newPatient) {
  //     const name =
  //       newPatient.user_first_name + " " + newPatient?.user_last_name;
  //     setServiceUser(name);
  //   }
  // }, []);

  const { bookingData } = useSelector((state) => state.patients);
  // const handleShow = (_, svc_id) => {
  // setShow(true);
  // setSelectedTitle(svc_name);
  // setSelectedId(svc_id);
  // };
  const handleEditModal = (data) => {
    // setEditmodal(true);
    // setRefresh(false);
    dispatch(setserviceData(data));
  };
  // const handleDelete = () => {
  //   if (selectedId) {
  //     dispatch(deleteService(selectedId));

  //     // setShow(false);
  //     // setRefresh(true);
  //   }
  // };
  // useEffect(() => {
  //   if (refresh) {
  //     dispatch(serviceList(facilityId));
  //   }
  // }, [dispatch, refresh, facilityId]);
  const serViceList = service.usr?.rec || [];
  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const HandleClick = (id) => {
    setSelectedColor(selectedColor === id ? null : id);
    setIsDisabled(isDisabled === id ? null : id);
  };

  return (
    <div>
      <Header
        pageTitle="My Orders > Add order > Services List"
        icon={<OrdersIcon />}
      />
      <div className="ser_title_b px-[16px] sm:px-8 mt-4">
        <h5>Services list for: {serviceUser}</h5>
        {role_id === "3" || role_id === "5" ? (
          ""
        ) : (
          <button
            onClick={() => {
              // setAddmodal(true);
            }}
            className="sign_btn"
          >
            Add New Service
          </button>
        )}
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {serViceList.length > 0 ? (
          serViceList.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <ServiceCard
                selectedId={facilityId}
                svcProfileID={svcf_user_profile_id}
                data={item}
                handleShow={() => {
                  // handleShow(item.svc_name, item.svc_id);
                }}
                handleEditModal={handleEditModal}
                roleID={role_id}
                HandleClick={() => HandleClick(item.svc_id)}
                selectedColor={selectedColor}
                isDisabled={isDisabled}
                dispatch={dispatch}
                bookingData={bookingData}
                userData={userData}
                selectedCardId={selectedCardId}
                setSelectedCardId={setSelectedCardId}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Services found</p>
          </Col>
        )}
      </Row>
      {/* <DeleteModal
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleDelete}
      />
      <AddModal
        show={addmodal}
        onHide={() => setAddmodal(false)}
        setRefresh={setRefresh}
        setAddmodal={setAddmodal}
        serviceid={facilityId}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
        serviceid={facilityId}
      /> */}
    </div>
  );
};
